import { useVdparXLSExport } from '../logic/useVdparXLSExport';
import { withSuspense } from 'venn-utils';

const VdparXLSExport = () => {
  useVdparXLSExport();

  return null;
};

export default withSuspense(null, VdparXLSExport);
